module.exports = __webpack_public_path__ + "img/train1.afe7eeb4.png";